import { useRegisterSW } from 'virtual:pwa-register/react';
import { useI18n } from '../i18n/i18n.js';
import { browserReloadDeps, reloadToUpdate } from './reloadToUpdate.js';

/** Lets the user decide when to load a new version instead of reloading mid-edit. */
export function UpdateBanner() {
  const { m } = useI18n();
  const {
    needRefresh: [needRefresh, setNeedRefresh],
  } = useRegisterSW();

  if (!needRefresh) return null;
  return (
    <div className="update-banner" role="status">
      {m.app.updateAvailable}
      <button
        type="button"
        className="btn btn-primary"
        onClick={() => void reloadToUpdate(browserReloadDeps)}
      >
        {m.app.reload}
      </button>
      <button type="button" className="btn btn-ghost" onClick={() => setNeedRefresh(false)}>
        {m.app.later}
      </button>
    </div>
  );
}
